<script>
import { mapGetters, mapActions } from "vuex";

import appStatuses from "../../service/contract-statuses";

import AppConfirm from "../../components/modals/app-confirm.vue";

import AdminContractPage from "../../components/AdminContractPage.vue";

import AdminContractSchetSummPage from "~/src/components/AdminContractSchetSummPage";
import AdminAppPaidShowEdit from "~/src/components/AdminAppPaidShowEdit.vue";
import AdminAppPaidShow from "~/src/components/AdminAppPaidShow.vue";
import AddGroupNumber from "~/src/components/AddGroupNumber.vue";
import AdminAppPaidShowPayment from "~/src/components/AdminAppPaidShowPayment.vue";
import axios from 'axios'
import { readableTextOn } from "~/src/utils/readable-text";

export default {
  components: {
    AdminContractSchetSummPage,
    AdminAppPaidShow,
    AppConfirm,
    AdminContractPage,
    AdminAppPaidShowEdit,
    AddGroupNumber,
    AdminAppPaidShowPayment,
  },

  data: () => ({
    tabs: {
      personal: "Personal info",
      edit: "Edit",
      payment: "Payment",
      groupAdd: "Add Group Number",
    },

    tab: "Personal info",

    loading: false,

    deleteDialog: false,

    isContract: false,

    isInvoice: false,

    pdfData: null,
  }),

  computed: {
    ...mapGetters("admin-contracts", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
    isAccounter: (vm) => vm.user.role == "ACCOUNTER",
    isAccounterHelper: (vm) => vm.user.role == "ACCOUNTER_HELPER",
    applicationStatus() {
      const status =
        appStatuses.find((x) => x.id == this.application.paidStatus) || {};

      return {
        name: status[`name-${this.$i18n.locale}`],
        color: color(status.id),
      };

      function color(statusName) {
        switch (statusName) {
          case "PAID":
            return "#26d317";
          case "HALF_PAID":
            return "#d8d813";
          case "NOT_PAID":
            return "#Fb0607";
          default:
            return null;
        }
      }
    },
  },

  created() {
    const id = this.$route.params.id;
    if (id != this.application.id) {
      this.INIT_BY_ID({ id }).then((status) => {
        if (!status) {
          this.$router.replace("/dashboard");
          return;
        }
      });
    }
  },

  methods: {
    // Dark text on the light status fills (the "Qisman" yellow, the "To'liq" green), white on the rest.
    textOn: readableTextOn,

    ...mapActions("admin-contracts", ["INIT_BY_ID", "DELETE_APPLICATION"]),

    ...mapActions("admin-contract", [
      "INIT_APPLICATION",
      "INIT_HISTORY",
      "INIT_ADD_GROUP",
    ]),

    onEdit() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.edit;
      });
    },

    onPayment() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.payment;
      });
    },

    navigateToAdmin() {
      this.$router.push("/contract_2022_2023");
    },

    onDelete() {
      this.loading = true;
      this.DELETE_APPLICATION(this.application).then((status) => {
        this.loading = false;
        if (status) {
          this.$router.replace("/contract_2022_2023");
        }
      });
    },

    onAddModel() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.groupAdd;
      });
    },

    async onDownloadContract() {
      this.loading = true;
      const id = this.application.applicationId;
      const data = await this.$axios.$get(`admin/contract/dogovor/${id}`);
      if (data) {
        this.pdfData = data;
        this.$nextTick(() => (this.isContract = true));
      } else {
        this.loading = false;
      }
    },

    async onDownloadContractInvoice() {
      this.loading = true;
      const id = this.application.applicationId;
      const data = await this.$axios.$get(`admin/contract/invoice/${id}`);
      if (data) {
        this.pdfData = data;
        this.$nextTick(() => (this.isInvoice = true));
      } else {
        this.loading = false;
      }
    },

    async generateContract(template_id) {
      const contractId = this.application?.id;
      if (!contractId) {
        this.$emit("error", "Contract ID not found.");
        return;
      }

      this.loadingId = template_id;

      try {
        const res = await axios.get(
          `/admin/contract/contract?contract_id=${contractId}&template_id=${template_id}`,
          { responseType: "blob" }
        );

        const blob = new Blob([res.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `contract-${template_id}.pdf`;
        link.click();
      } catch (e) {
        console.error(e);
        this.$emit("error", "Xatolik yuz berdi");
      } finally {
        this.loadingId = null;
      }
    },
  },
  

};
</script>

<template>
  <div class="pb-5">
    <admin-contract-page
      v-if="isContract && pdfData"
      :pdfData="pdfData"
      @close="
        () => {
          isContract = false;
          loading = false;
        }
      "
    />
    <admin-contract-schet-summ-page
      v-if="isInvoice && pdfData"
      :pdfData="pdfData"
      @close="
        () => {
          isInvoice = false;
          loading = false;
        }
      "
    />

    <app-confirm
      v-model="deleteDialog"
      :text="$t('Do you really want to delete?')"
      @accept="onDelete"
    />

    <v-container style="display: flex;">
      <v-btn
          @click="navigateToAdmin"
          elevation="0"
          rounded
          large
          class="font-made modern-back-btn mb-6 px-6 py-3 d-flex align-center"
          style="
          border: 1px solid #e0e0e0;
          background: linear-gradient(135deg, #ffffff, #f9f9f9);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.25s ease;
        "
      >
        <v-icon
            left
            size="22"
            style="color:#0c0c0c; transition: transform 0.2s;"
            class="back-icon"
        >
          mdi-arrow-left
        </v-icon>
        <span
            class="font-weight-bold text-uppercase"
            style="letter-spacing:1px; font-size:14px; color:#0c0c0c;"
        >
          {{ $t("Back") }}
        </span>
      </v-btn>

      <div class="-status-wrap" style="width: 100%; height: 100%;">
        <div v-if="application.converted"
          class="-status"
          :style="{ backgroundColor: applicationStatus.color, color: textOn(applicationStatus.color) }"
        >
          Talaba keyingi bosqichga ko`chirilgan
        </div>
        <div v-else
          class="-status"
          :style="{ backgroundColor: applicationStatus.color, color: textOn(applicationStatus.color) }"
        >
          {{ application.kurs }} - {{ $t("kurs talabasi") }},
          {{ $t("Status") }}: {{ applicationStatus.name }},
          {{ $t("Kontract summasi") }} {{ $comma(application.totalSumma) }},
          {{ $t("Qoldiq") }}
          {{ $comma(application.totalOstatok) }}
        </div>
      </div>
    </v-container>

    <v-container class="-wrap">
      <div class="pa-5">
        <div header>
          <div class="title pb-2 text-center accent--text tab-title" v-text="$t(tab)" />

          <div class="title-actions pb-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  elevation="0"
                  color="accent"
                  @click="tab = tabs.personal"
                  :outlined="tab != tabs.personal"
                  class="px-0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon> mdi-badge-account-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Personal info") }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="isSupperAdmin">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  @click="onEdit"
                  :outlined="tab != tabs.edit"
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                >
                  <v-icon> mdi-file-document-edit-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>

            <v-tooltip
              bottom
              v-if="isSupperAdmin || isAccounter"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  @click="onPayment"
                  :outlined="tab != tabs.payment"
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                >
                  <v-icon> mdi-file-document-edit-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Payment") }}</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="isSupperAdmin || isAccounter || isAccounterHelper"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  @click="onAddModel"
                  :outlined="tab != tabs.groupAdd"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                >
                  <v-icon> mdi-plus </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Add Group Number") }}</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="application.paidStatus !== 'PAID'"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                  @click="onDownloadContract"
                >
                  <v-icon> mdi-file-check-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract") }}</span>
            </v-tooltip>

            <v-tooltip v-if="isSupperAdmin" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  large
                  color="red"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                  @click="deleteDialog = true"
                >
                  <v-icon> mdi-delete-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }" >
                <v-btn
                  :disabled="loading"
                  large
                  color="accent"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-0 ml-5"
                  @click="generateContract(1000)"
                >
                  <v-icon> mdi-file-pdf </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract_schet_pechat") }}</span>
            </v-tooltip>
          </div>

          <div class="position-relative">
            <v-progress-linear
              top
              absolute
              :active="loading"
              indeterminate
              posi
            />
          </div>
          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt="" />
          </div>
        </div>

        <div body class="pt-5">
          <admin-app-paid-show v-if="tab == tabs.personal" />
          <admin-app-paid-show-edit v-else-if="tab == tabs.edit" />
          <add-group-number v-else-if="tab == tabs.groupAdd" />
          <AdminAppPaidShowPayment v-else-if="tab == tabs.payment" />
        </div>
      </div>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.-status-wrap {
  display: flex;
  justify-content: center;

  .-status {
    padding: 8px 5px;
    border-radius: 10px;
    margin-left: 35px;
    margin-right: 35px;
    width: 100%;
    text-align: center;
    cursor: default;
    font-size: 18px;
    color: white;
  }
}

.-wrap {
  background: rgba(154, 154, 154, 0.2);
  border-radius: 10px;

  .title-actions {
    .v-btn {
      min-width: 44px;
    }
  }
}

.modern-back-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
}

.modern-back-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.back-icon:hover {
  transform: translateX(-3px);
}
</style>
